export const SMS_PROMPT_MODAL_SEEN_DETAILS =
  'crw_tap_sms_prompt_modal_seen_details';
